/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVmMongo } from '../models/custom-result-of-audit-vm-mongo';
import { CustomResultOfInboxesByParserWithPaginationDto } from '../models/custom-result-of-inboxes-by-parser-with-pagination-dto';
import { CustomResultOfInboxesWithPaginationDto } from '../models/custom-result-of-inboxes-with-pagination-dto';
import { CustomResultOfListOfString } from '../models/custom-result-of-list-of-string';
import { CustomResultOfPollParserInboxesStatisticsDto } from '../models/custom-result-of-poll-parser-inboxes-statistics-dto';
import { inboxesGetInboxAudits } from '../fn/inboxes/inboxes-get-inbox-audits';
import { InboxesGetInboxAudits$Params } from '../fn/inboxes/inboxes-get-inbox-audits';
import { inboxesGetInboxesByPollParserIdWIthPagination } from '../fn/inboxes/inboxes-get-inboxes-by-poll-parser-id-w-ith-pagination';
import { InboxesGetInboxesByPollParserIdWIthPagination$Params } from '../fn/inboxes/inboxes-get-inboxes-by-poll-parser-id-w-ith-pagination';
import { inboxesGetInboxesByPollParserLottery } from '../fn/inboxes/inboxes-get-inboxes-by-poll-parser-lottery';
import { InboxesGetInboxesByPollParserLottery$Params } from '../fn/inboxes/inboxes-get-inboxes-by-poll-parser-lottery';
import { inboxesGetInboxesByTextParserIdWithPagination } from '../fn/inboxes/inboxes-get-inboxes-by-text-parser-id-with-pagination';
import { InboxesGetInboxesByTextParserIdWithPagination$Params } from '../fn/inboxes/inboxes-get-inboxes-by-text-parser-id-with-pagination';
import { inboxesGetInboxesStatisticsByPollParserId } from '../fn/inboxes/inboxes-get-inboxes-statistics-by-poll-parser-id';
import { InboxesGetInboxesStatisticsByPollParserId$Params } from '../fn/inboxes/inboxes-get-inboxes-statistics-by-poll-parser-id';
import { inboxesGetInboxesWithPagination } from '../fn/inboxes/inboxes-get-inboxes-with-pagination';
import { InboxesGetInboxesWithPagination$Params } from '../fn/inboxes/inboxes-get-inboxes-with-pagination';
import { inboxesGetUsersInboxesWithPagination } from '../fn/inboxes/inboxes-get-users-inboxes-with-pagination';
import { InboxesGetUsersInboxesWithPagination$Params } from '../fn/inboxes/inboxes-get-users-inboxes-with-pagination';
import { inboxesUpdateInboxInboxGroup } from '../fn/inboxes/inboxes-update-inbox-inbox-group';
import { InboxesUpdateInboxInboxGroup$Params } from '../fn/inboxes/inboxes-update-inbox-inbox-group';
import { inboxesUpdateInboxIsRead } from '../fn/inboxes/inboxes-update-inbox-is-read';
import { InboxesUpdateInboxIsRead$Params } from '../fn/inboxes/inboxes-update-inbox-is-read';
import { inboxesUpdateInboxStatus } from '../fn/inboxes/inboxes-update-inbox-status';
import { InboxesUpdateInboxStatus$Params } from '../fn/inboxes/inboxes-update-inbox-status';

@Injectable({ providedIn: 'root' })
export class InboxesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inboxesUpdateInboxIsRead()` */
  static readonly InboxesUpdateInboxIsReadPath = '/Inboxes/UpdateInboxIsRead';

  /**
   * Update Inbox Is Read Field.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesUpdateInboxIsRead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxIsRead$Response(params: InboxesUpdateInboxIsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxesUpdateInboxIsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Inbox Is Read Field.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesUpdateInboxIsRead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxIsRead(params: InboxesUpdateInboxIsRead$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxesUpdateInboxIsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxesUpdateInboxStatus()` */
  static readonly InboxesUpdateInboxStatusPath = '/Inboxes/UpdateInboxStatus';

  /**
   * ویرایش وضعیت صندوق های دریافت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesUpdateInboxStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxStatus$Response(params: InboxesUpdateInboxStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxesUpdateInboxStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش وضعیت صندوق های دریافت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesUpdateInboxStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxStatus(params: InboxesUpdateInboxStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxesUpdateInboxStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxesUpdateInboxInboxGroup()` */
  static readonly InboxesUpdateInboxInboxGroupPath = '/Inboxes/UpdateInboxInboxGroup';

  /**
   * Update Inbox InboxGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesUpdateInboxInboxGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxInboxGroup$Response(params: InboxesUpdateInboxInboxGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return inboxesUpdateInboxInboxGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Inbox InboxGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesUpdateInboxInboxGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesUpdateInboxInboxGroup(params: InboxesUpdateInboxInboxGroup$Params, context?: HttpContext): Observable<CustomResult> {
    return this.inboxesUpdateInboxInboxGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxesWithPagination()` */
  static readonly InboxesGetInboxesWithPaginationPath = '/Inboxes/GetInboxesWithPagination';

  /**
   * Get Inboxes With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesWithPagination$Response(params: InboxesGetInboxesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInboxesWithPaginationDto>> {
    return inboxesGetInboxesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inboxes With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesWithPagination(params: InboxesGetInboxesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfInboxesWithPaginationDto> {
    return this.inboxesGetInboxesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInboxesWithPaginationDto>): CustomResultOfInboxesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxesByPollParserIdWIthPagination()` */
  static readonly InboxesGetInboxesByPollParserIdWIthPaginationPath = '/Inboxes/GetInboxesByPollParserIdWIthPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxesByPollParserIdWIthPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesByPollParserIdWIthPagination$Response(params: InboxesGetInboxesByPollParserIdWIthPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInboxesByParserWithPaginationDto>> {
    return inboxesGetInboxesByPollParserIdWIthPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxesByPollParserIdWIthPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesByPollParserIdWIthPagination(params: InboxesGetInboxesByPollParserIdWIthPagination$Params, context?: HttpContext): Observable<CustomResultOfInboxesByParserWithPaginationDto> {
    return this.inboxesGetInboxesByPollParserIdWIthPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInboxesByParserWithPaginationDto>): CustomResultOfInboxesByParserWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxesByTextParserIdWithPagination()` */
  static readonly InboxesGetInboxesByTextParserIdWithPaginationPath = '/Inboxes/GetInboxesByTextParserIdWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxesByTextParserIdWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesByTextParserIdWithPagination$Response(params: InboxesGetInboxesByTextParserIdWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInboxesByParserWithPaginationDto>> {
    return inboxesGetInboxesByTextParserIdWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxesByTextParserIdWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxesByTextParserIdWithPagination(params: InboxesGetInboxesByTextParserIdWithPagination$Params, context?: HttpContext): Observable<CustomResultOfInboxesByParserWithPaginationDto> {
    return this.inboxesGetInboxesByTextParserIdWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInboxesByParserWithPaginationDto>): CustomResultOfInboxesByParserWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxAudits()` */
  static readonly InboxesGetInboxAuditsPath = '/Inboxes/GetInboxAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxAudits$Response(params: InboxesGetInboxAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVmMongo>> {
    return inboxesGetInboxAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetInboxAudits(params: InboxesGetInboxAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVmMongo> {
    return this.inboxesGetInboxAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVmMongo>): CustomResultOfAuditVmMongo => r.body)
    );
  }

  /** Path part for operation `inboxesGetUsersInboxesWithPagination()` */
  static readonly InboxesGetUsersInboxesWithPaginationPath = '/Inboxes/GetUsersInboxesWithPagination';

  /**
   * Get Users Inboxes With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetUsersInboxesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetUsersInboxesWithPagination$Response(params: InboxesGetUsersInboxesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfInboxesWithPaginationDto>> {
    return inboxesGetUsersInboxesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Users Inboxes With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetUsersInboxesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inboxesGetUsersInboxesWithPagination(params: InboxesGetUsersInboxesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfInboxesWithPaginationDto> {
    return this.inboxesGetUsersInboxesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfInboxesWithPaginationDto>): CustomResultOfInboxesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxesStatisticsByPollParserId()` */
  static readonly InboxesGetInboxesStatisticsByPollParserIdPath = '/Inboxes/GetInboxesStatisticsByPollParserId';

  /**
   * دریافت آمار دریافت پیام بر اساس شناسه مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxesStatisticsByPollParserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxesGetInboxesStatisticsByPollParserId$Response(params?: InboxesGetInboxesStatisticsByPollParserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPollParserInboxesStatisticsDto>> {
    return inboxesGetInboxesStatisticsByPollParserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار دریافت پیام بر اساس شناسه مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxesStatisticsByPollParserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxesGetInboxesStatisticsByPollParserId(params?: InboxesGetInboxesStatisticsByPollParserId$Params, context?: HttpContext): Observable<CustomResultOfPollParserInboxesStatisticsDto> {
    return this.inboxesGetInboxesStatisticsByPollParserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPollParserInboxesStatisticsDto>): CustomResultOfPollParserInboxesStatisticsDto => r.body)
    );
  }

  /** Path part for operation `inboxesGetInboxesByPollParserLottery()` */
  static readonly InboxesGetInboxesByPollParserLotteryPath = '/Inboxes/GetInboxesByPollParserLottery';

  /**
   * دریافت لیست شماره ها برای قرعه کشی مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inboxesGetInboxesByPollParserLottery()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxesGetInboxesByPollParserLottery$Response(params?: InboxesGetInboxesByPollParserLottery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfString>> {
    return inboxesGetInboxesByPollParserLottery(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست شماره ها برای قرعه کشی مسابقه یا نظرسنجی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inboxesGetInboxesByPollParserLottery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inboxesGetInboxesByPollParserLottery(params?: InboxesGetInboxesByPollParserLottery$Params, context?: HttpContext): Observable<CustomResultOfListOfString> {
    return this.inboxesGetInboxesByPollParserLottery$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfString>): CustomResultOfListOfString => r.body)
    );
  }

}
